// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__1OX4g","wrapper":"LoginForm_wrapper__1IVsS","input":"LoginForm_input__278Ts","label":"LoginForm_label__2Myz_"};